import { CheckIcon, WarningCircleIcon } from "@phosphor-icons/react/dist/ssr";
import type { ComponentPropsWithRef, ReactNode } from "react";
import { isObject } from "@/core/shared/v2/common/helpers/lang";
import { cn } from "@/core/shared/v2/lib/utils";

export type InputWrapperWrap = boolean | Omit<ComponentPropsWithRef<"div">, "children">;

export interface InputWrapperProps {
  children: ReactNode;
  wrap?: InputWrapperWrap;
  showCheckIcon?: boolean;
}

export function InputWrapper({ wrap, children, showCheckIcon = false }: InputWrapperProps) {
  const { className, ...props } = (isObject(wrap) ? wrap : {}) as ComponentPropsWithRef<"div">;

  const wrapperClasses = "relative group";
  const iconBaseClasses = "hidden absolute top-1/2 right-3 size-6 -translate-y-1/2 pointer-events-none";

  const visibilityLogic = cn(
    "[&:has(input[aria-invalid='true']:not(:disabled))_.warning-icon]:block",
    "[&:has(input[aria-invalid='false']:not(:disabled))_.check-icon]:block",
    "[&:has(textarea[aria-invalid='true']:not(:disabled))_.warning-icon]:top-1 [&:has(textarea[aria-invalid='true']:not(:disabled))_.warning-icon]:right-1 [&:has(textarea[aria-invalid='true']:not(:disabled))_.warning-icon]:translate-y-0",
    "[&:has(textarea[aria-invalid='false']:not(:disabled))_.check-icon]:top-1 [&:has(textarea[aria-invalid='false']:not(:disabled))_.check-icon]:right-1 [&:has(textarea[aria-invalid='false']:not(:disabled))_.check-icon]:translate-y-0",
    "[&:has(select[aria-invalid='true']:not(:disabled))_.warning-icon]:block",
    "[&:has(select[aria-invalid='false']:not(:disabled))_.check-icon]:block",
  );

  return (
    <div className={cn(wrapperClasses, visibilityLogic, className)} {...props}>
      {children}
      <WarningCircleIcon className={cn(iconBaseClasses, "warning-icon text-destructive")} />
      {showCheckIcon && <CheckIcon className={cn(iconBaseClasses, "check-icon text-foreground")} />}
    </div>
  );
}
